import { parseUA } from "../parseUA";
export default function getSystemInfo() {
  var result = parseUA();
  return Promise.resolve(result);
}